
/*Package importing*/
import React, { Component } from 'react';

/*Components*/


/*Assets*/
class AddNewBusiness extends Component {
  constructor(props){
    super(props);
    this.state = {

    }
  }

  componentDidMount() {

  }

  render() {
    
    return (
      <div className="e-main-content e-driver-detail-wrap e-dash-wrap">
        <h2 className="e-page-head">Business Listing</h2>
        
      </div>
      
    );
  }
}

export default AddNewBusiness;
